import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/support").then((module) => ({
    default: module.Support,
  })),
);

export const Route = createFileRoute("/admin/support/")({
  component: Page,
});
